import {OsisRuleListItem} from '../../../integrated-client/models/';

interface ITableData {
  records: Array<OsisRuleListItem>
  totalItems?: number
}

export class TableData implements ITableData{
  records: Array<OsisRuleListItem>
  totalItems?: number

  constructor() {
    this.records = [];
  }

}
